import React from "react";
import Page from "../../common/page/Page";
import useTranslationDashboard from "../useTranslationDashboard";
import useAuthUser from "../../authentication-no-ui/useAuthUser";
import DashboardBlock from "./DashboardBlock";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized";

export default function DashboardPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationDashboard();
  useShowLoader(tLoading, "DashboardPage");

  const { profile } = useAuthUser();

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="DashboardPage">
          <Page.Title
            text={t("dashboard:recruiters_dashboard_title")}
            loading={tLoading}
          />
          <Page.Content>
            <DashboardBlock recruiterId={profile._id} />
          </Page.Content>
        </Page>
      )}
    />
  );
}
